module.exports = __webpack_public_path__ + "img/jimeng.eebde803.png";